/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import ChangeBadge from '../../../../../material/changebadge/changebadge';
// styles
import injectSheet from 'react-jss';
import styles from './charttable_styles';


/* ========== ~~~~~~~~~~ CHART TABLE ~~~~~~~~~~ ========== */
const ChartTable = injectSheet(styles)((props) => {
    const { title, value, changeDirection, change } = props;
    return (
        <div className={`charttable ${props.classes.charttable}`} >
            <span className={'title'}>{title}</span>
            <div className={'valuebadge'}>
                <span className={'value'}>{value}</span>
                { props.changeType && props.changeType.toLowerCase() !== 'pop' &&
                    <div className={'badgechange'}>
                        <ChangeBadge direction={changeDirection} change={change}/>
                        <span className={'changetype'}>{props.changeType}</span>
                    </div>
                }
            </div>
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ChartTable;
